import React from "react";

function ArrowIcon({ showQuestions }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="13"
      viewBox="0 0 23 13"
      fill="none"
      style={{
        transform: showQuestions ? "" : "rotate(-180deg)",
      }}
    >
      <path d="M1.5 1L11.5 11L21.5 1" stroke="#110E17" strokeWidth="2.51828" />
    </svg>
  );
}

export default ArrowIcon;
